type CloseFn = () => void;

const closers = new Set<CloseFn>();

/**
 * How a `RedScreen` — mounted wherever the current scan screen happens to render it — closes a
 * sheet that lives somewhere else in the app shell entirely. The queue's "Needs attention" sheet
 * and the site switcher are owned by `ScanLayout`; the ship sheets are owned by `ShipOrder`. A
 * scan can be refused while any of them is open, because the camera and a Bluetooth scanner both
 * keep reading behind an open sheet.
 *
 * Closing it is not an optional extra once the overlay is visually on top: a Radix modal calls
 * `hideOthers` on the rest of the DOM for as long as it stays open, so a `RedScreen` rendered
 * outside that dialog's own subtree is `aria-hidden` regardless of z-index, until the dialog is
 * actually gone. Covering a sheet is not the same as replacing it.
 *
 * Each sheet owner registers how to close itself — and to mark that it must not hand focus back
 * to whatever opened it — with `registerRefusalCloser`. `RedScreen` calls `announceRefusal` once,
 * on mount, and every currently-registered sheet closes.
 */
export function registerRefusalCloser(close: CloseFn): () => void {
  closers.add(close);
  return () => {
    closers.delete(close);
  };
}

export function announceRefusal(): void {
  for (const close of closers) close();
}
